import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import type { ApplicationConfig } from '@angular/core';
import { MomentDateAdapter, provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
    type InMemoryScrollingFeature,
    type InMemoryScrollingOptions,
    provideRouter,
    withInMemoryScrolling,
} from '@angular/router';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { routes } from './app.routes';
import { AuthGuard } from './shared/guard/auth.guard';
import { reqInterceptor } from './shared/interceptors/req.interceptor';
import { errorInterceptor } from './shared/interceptors/error.interceptor';
// import { reqInterceptor } from './shared/interceptors/req.interceptor';
registerLocaleData(localePt, 'pt');

const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, inMemoryScrollingFeature),
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        provideMomentDateAdapter({
            parse: {
                dateInput: 'DD/MM/YYYY',
            },
            display: {
                dateInput: 'DD/MM/YYYY',
                monthYearLabel: 'MMM YYYY',
                dateA11yLabel: 'LL',
                monthYearA11yLabel: 'MMMM-YYYY',
            },
        }),
        HttpClientModule,
        AuthGuard,
        provideAnimationsAsync(),
        provideEnvironmentNgxMask(),
        provideAnimationsAsync(),
        provideAnimationsAsync(),
        provideAnimationsAsync(),
        provideHttpClient(withInterceptors([reqInterceptor, errorInterceptor])),
        DatePipe,
    ],
};
